"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const Flex_1 = __importDefault(require("../Flex"));
const Plate = (0, styled_components_1.default)(Flex_1.default).attrs((props) => ({
    direction: props.direction,
    width: props.w || props.width,
    height: props.h || props.height || 'auto',
    align: props.align || 'flex-start',
    justify: props.justify || 'flex-start',
    padding: props.padding || props.p || '40px',
    margin: props.margin || '0 0 20px 0',
})) `
  border-radius: 8px;
  background: #fff;
  color: #333;
  font-family: Inter, sans-serif;
  box-sizing: border-box;
`;
exports.default = Plate;
